(function () {
  "use strict";

  EditProfileCtrl.$inject = ['$scope', '$timeout', 'accountService', 'textLengthIndicatorState', 'refreshSession', 'usersResource', 'accountFeatures', 'mtypes', 'errorHandler'];
  angular
    .module('trainerWebApp.modals')
    .controller('EditProfileCtrl', EditProfileCtrl);

  function EditProfileCtrl($scope, $timeout, accountService, textLengthIndicatorState, refreshSession, usersResource, accountFeatures, mtypes, errorHandler) {

    var needPlaceHolderSupport = BrowserDetect.browser == 'Explorer' && BrowserDetect.version < 10;
    var formFieldValidityCache = {};
    var formAllTextLengthKeys = {
      firstName: 35,
      lastName: 35,
      email: 254,
      password: 35
    };

    var requiredKeys = ['firstName', 'lastName', 'email'];

    function recalcFormTextLengthIndicators() {
      for (var key in formAllTextLengthKeys) {
        _validateFormTextLength(key);
      }
      $scope.modal.valid = calcFormValidity();
    }

    $scope.onFormFieldInputBlur = function (key) {
      // leave errors
      var state = formFieldValidityCache[key];
      if (!state.lengthValid || !state.dataValid)
        return;

      applyFormState(key, textLengthIndicatorState.defaultState);
    };

    var emailRegex = /^[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?\.)+[a-zA-Z0-9](?:[a-zA-Z0-9-]*[a-zA-Z0-9])?$/;

    function _validateFormTextLength(key) {
      var text = $scope.modal.data[key];
      var state = textLengthIndicatorState.getState(text, formAllTextLengthKeys[key]);

      if (~requiredKeys.indexOf(key) && (!text || !text.trim().length > 0)) {
        state.dataValid = false;
      } else if (key === 'email') {
        state.dataValid = state.lengthValid && emailRegex.test($scope.modal.data[key]);
      } else if (key === 'password') {
        $scope.modal.passwordError = "";
        $scope.modal.confirmPasswordError = "";
        $scope.passwordStyle = '';
        $scope.confirmPasswordStyle = '';
        if (text && text.trim().length > 0) {
          var password2 = $scope.modal.data['password2'] || '';
          state.dataValid = (text.trim().length > 7 && state.lengthValid && text == password2);

          if (text.length > 0 && text.length < 8) {
            $scope.passwordStyle = 'redBorder';
            $scope.modal.passwordError = "password must be 8 or more characters";
          } else if (password2.length > 0 && password2.length < 8) {
            $scope.confirmPasswordStyle = 'redBorder';
            $scope.modal.passwordError = "password must be 8 or more characters";
          } else if (!state.dataValid && password2.length >= 8 && text.length >= 8) {
            $scope.passwordStyle = 'redBorder';
            $scope.confirmPasswordStyle = 'redBorder';
            $scope.modal.passwordError = "password doesn't match";

          }
        }
      }

      applyFormState(key, state);
      formFieldValidityCache[key] = state;
    }

    $scope.validateFormTextLength = function (key) {
      _validateFormTextLength(key);
      $scope.modal.valid = calcFormValidity();
      $scope.modal.dirty = calcFormDirty();
    };

    $scope.onFormFieldFocus = function (key) {
      applyFormState(key, formFieldValidityCache[key]);
    };

    $scope.clearErrorMessage = function () {
      $scope.currentPasswordStyle = '';
      $scope.modal.currentPasswordError = '';
    };

    function applyFormState(key, state) {
      $scope[key + 'IndicatorStyle'] = state.style;
      $scope[key + 'IndicatorText'] = state.text;
      if (key !== 'password')
        $scope[key + 'Style'] = state.dataValid ? '' : 'redBorder';
    }

    function calcFormValidity() {
      for (var key in formFieldValidityCache) {

        if (key === 'email') {
          formFieldValidityCache[key] = getEmailState();
        }
        if (key === 'password') {
          formFieldValidityCache[key] = getPasswordState();
        }

        if (!formFieldValidityCache[key].lengthValid || !formFieldValidityCache[key].dataValid)
          return false;
      }
      return true;
    }

    function calcFormDirty() {
      if (($scope.userForm.oldPassword.$dirty ||
        $scope.userForm.password.$dirty ||
        $scope.userForm.passwordConfirm.$dirty)) {
        return true;
      }

      for (var key in formFieldValidityCache) {
        if ($scope.modal.data[key] && $scope.modal.data[key].trim() != storedUserInfo[key])
          return true;
      }
      return false;
    }

    function getEmailState() {
      var key = 'email';
      var emailText = $scope.modal.data[key];
      // initial load
      if(emailText === undefined)
        return  {lengthValid: true, dataValid: true};

      // trainee with a username
      if(!valueMissing('username'))
        return  {lengthValid: true, dataValid: true};

      var state = textLengthIndicatorState.getState(emailText, formAllTextLengthKeys[key]);


      // email is required when a trainee lacks a username
      if(valueMissing('username') && valueMissing('email'))
        return state;

      // test valid email regex
      if(!emailRegex.test(emailText)) {
        state.dataValid = false;
        return state;
      }

      return  {lengthValid: true, dataValid: true};
    }

    function getPasswordState() {
      if (!$scope.modal.data.currentPassword && !$scope.userForm.password.$viewValue && !$scope.userForm.passwordConfirm.$viewValue) {
        return {lengthValid: true, dataValid: true};
      }

      if (!$scope.modal.data.currentPassword) {
        return {lengthValid: false, dataValid: false};
      }

      return {
        lengthValid: !$scope.userForm.password.$error.passwordLen,
        dataValid: $scope.userForm.password.$viewValue &&
        $scope.userForm.passwordConfirm.$viewValue &&
        !$scope.userForm.password.$error.any &&
        !$scope.userForm.passwordConfirm.$error.compareTo
      };
    }

    function valueMissing(key) {
      return !$scope.modal.data[key] || $scope.modal.data[key].trim().length === 0;
    }

    $scope.form = {
      valid: true,
      dirty: false
    };

    var storedUserInfo = {};

    $scope.modal = {
      content: 0,
      data: {
        userId: '',
        firstName: '',
        lastName: '',
        email: '',
        password: '',
        password2: '',
        currentPassword: ''
      },
      status: ''
    };

    $scope.modal.status = 'loading';

    accountService.getAccountInfo({}, function (res) {
      storedUserInfo = res;
      $scope.modal.status = '';
      $scope.modal.data = {
        userId: res.userId,
        firstName: res.firstName,
        lastName: res.lastName,
        email: res.email,
        password: '',
        currentPassword: ''
      };

      showPermissionsMessage(res);

      recalcFormTextLengthIndicators();

//        // only need placeholder support for IE8 and IE9
      if (needPlaceHolderSupport) {
        $('label[for="firstName"]').hide();
        $('label[for="lastName"]').hide();
        $('label[for="email"]').hide();
        $('#password').placeholder();
        $('#password2').placeholder();
      }
    });
//    });


    function showPermissionsMessage(info) {
      $scope.permissionsMessage = "";
      if (accountFeatures.features.indexOf(mtypes.featureEntry.userMgmtRestrictions) == -1)
        return;

      if (info.permissions == mtypes.userRole.administrator)
        return;

      if (info.allowedGroups && info.allowedGroups.length > 0) {
        usersResource.getUserGroupsRestrictions(info.userId, function (result) {
          var groupNames = _.pluck(result, 'groupName');

          if (info.permissions == mtypes.userRole.reporter) {
            $scope.permissionsMessage = "Your account has Reporter permissions to view reports, and download reports and certificates in the following groups: " + groupNames.join(", ");
          } else if (info.permissions == mtypes.userRole.teamLead) {
            $scope.permissionsMessage = "Your account has Team Lead permissions to view reports and manage trainees in the following groups: " + groupNames.join(", ") + ". You cannot add, invite, or drop trainees.";
          } else if (info.permissions == mtypes.userRole.manager) {
            $scope.permissionsMessage = "Your account has Manager permissions to view and manage trainees in the following groups: " + groupNames.join(", ");
          } else if (info.permissions == mtypes.userRole.trainer) {
            $scope.permissionsMessage = "Your account has Trainer permissions to create courses. You can view and manage trainees in the following groups: " + groupNames.join(", ");
          }
        });
      } else {
        if (info.permissions == mtypes.userRole.reporter) {
          $scope.permissionsMessage = "Your account has Reporter permissions to view reports, and download reports and certificates in all groups.";
        } else if (info.permissions == mtypes.userRole.teamLead) {
          $scope.permissionsMessage = "Your account has Team Lead permissions to view reports and manage trainees in all groups. You cannot add, invite, or drop trainees.";
        } else if (info.permissions == mtypes.userRole.manager) {
          $scope.permissionsMessage = "Your account has Manager permissions to view and manage trainees in all groups.";
        } else if (info.permissions == mtypes.userRole.trainer) {
          $scope.permissionsMessage = "Your account has Trainer permissions to create courses. You can view and manage trainees in all groups.";
        }
      }

    }

    $scope.saveUser = function () {
      $scope.modal.status = 'saving';

      var info = {};

      if (fieldChanged('firstName'))
        info.firstName = $scope.modal.data.firstName;
      if (fieldChanged('lastName'))
        info.lastName = $scope.modal.data.lastName;
      if (fieldChanged('email'))
        info.email = $scope.modal.data.email;
      if ($scope.modal.data.password)
        info.password = $scope.modal.data.password;
      if ($scope.modal.data.currentPassword)
        info.currentPassword = $scope.modal.data.currentPassword;

      usersResource.updateUserInfo(
        $scope.modal.data.userId,
        info,
        function (res) {
          $scope.$dismiss();
          refreshSession.refresh();
        },
        function (err) {
          if(err && err.data === "The current password is incorrect") {
            $scope.modal.currentPasswordError = 'current password is incorrect';
            $scope.currentPasswordStyle = 'redBorder';
          } else {
            $scope.$dismiss();
            $timeout(errorHandler.showGenericServerError);
          }
          $scope.modal.status = '';
          return true;
        }
      );
    };

    function fieldChanged(arg) {
      return $scope.modal.data[arg] != storedUserInfo[arg];
    }

  }

})();
